import type { DashboardDataParamsDto, DashboardDto } from "../types/dashboard";
import { apiService } from "./apiService";
import { getErrorMessage } from "./errorHandling";

export const getDashboardData = async (params: DashboardDataParamsDto) => {
  try {
    return await apiService<DashboardDto>({ method: "get", url: "/jobs/dashboard_options_view/", params });
  } catch (error: any) {
    throw getErrorMessage(error);
  }
};
